import React from 'react';
import VideoCard from './VideoCard';
import { ScrollArea } from '@/components/ui/scroll-area';
import { YouTubeSearchResult } from '@/lib/youtubeApi';
import type { VideoItem, Collection } from '@/lib/supabase';

interface SearchResultsProps {
  results: YouTubeSearchResult[];
  collections: Collection[];
  onAddVideo: (video: VideoItem, collectionId: string) => void;
  isLoading: boolean;
}

const SearchResults: React.FC<SearchResultsProps> = ({ 
  results, 
  collections,
  onAddVideo,
  isLoading 
}) => {
  if (isLoading) {
    return (
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="bg-secondary rounded-lg h-[360px] animate-pulse" />
        ))}
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="mt-4 text-center text-muted-foreground">
        No videos found. Try another search term.
      </div>
    );
  }

  return (
    <ScrollArea className="h-[calc(100vh-250px)] mt-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 pr-4">
        {results.map((result) => {
          const video: VideoItem = {
            id: result.id.videoId,
            videoId: result.id.videoId,
            title: result.snippet.title,
            thumbnail: result.snippet.thumbnails.high.url, // Use higher quality thumbnails
          };
          
          const handleAdd = (collectionId: string) => {
            onAddVideo(video, collectionId);
          };

          return (
            <VideoCard
              key={video.id}
              video={video}
              collections={collections}
              onAdd={handleAdd}
            />
          );
        })}
      </div>
    </ScrollArea>
  );
};

export default SearchResults;